import { Col, Row, Space, Typography } from "antd";
import { getDateStringLocale, getTodayString } from "helper/common";
import moment from "moment";
import React from "react";
import "./Sign.scss";
const Sign = (props) => {
  const {
    nguoiThucHien,
    label = "Người thực hiện",
    time,
    showTime = true,
    size = 64,
    style = {
      marginTop: "36px",
      marginRight: "15px",
    },
    justify = "end",
    chanKy = true,
    name = "(Ký và ghi rõ họ tên)",
    subLabel = true,
    span = 10,
    isRow = true,
    textAlign = "end",
  } = props;
  return (
    <Row style={{ ...style }} className="sign" justify={justify}>
      <Col span={span} style={{ textAlign: textAlign }}>
        <Space direction="vertical" size={size}>
          <Col>
            {showTime && (
              <Row
                justify={"center"}
                style={{ height: showTime ? "22px" : "" }}
              >
                {isRow && (
                  <Typography.Text className="date-sign">
                    {getDateStringLocale(time ?? moment().format())}
                  </Typography.Text>
                )}
              </Row>
            )}
            <Row justify={"center"}>
              <Typography.Text strong>{label}</Typography.Text>
            </Row>
            {subLabel ? (
              <Row justify={"center"}>
                <Typography.Text style={{ color: "rgb(0 0 0/0.65)" }}>
                  {name}
                </Typography.Text>
              </Row>
            ) : (
              <Row style={{ paddingTop: "22px" }}></Row>
            )}
          </Col>
          {chanKy && (
            <Row justify={"center"}>
              <Typography.Text strong>
                {nguoiThucHien ?? localStorage.getItem("fullName")}
              </Typography.Text>
            </Row>
          )}
        </Space>
      </Col>
      {/* <Row></Row> */}
    </Row>
  );
};
export default Sign;
